import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.5 19.5"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"Group 5637\"><g data-name=\"Group 5630\"><g data-name=\"Group 5627\"><path data-name=\"Path 8487\" d=\"M19.06 1.94A1.474 1.474 0 0 0 18 1.5h-2.25V0h-1.5v1.5h-9V0h-1.5v1.5H1.5a1.458 1.458 0 0 0-1.06.44A1.458 1.458 0 0 0 0 3v15a1.474 1.474 0 0 0 .44 1.06 1.5 1.5 0 0 0 1.06.44H18a1.5 1.5 0 0 0 1.5-1.5V3a1.5 1.5 0 0 0-.44-1.06\" style=\"fill-rule:evenodd;fill:#f59600;\"></path></g></g><path data-name=\"Path 8482 - Outline\" d=\"M5.549 2.5h1.866v3.049h3.049v1.866H7.415v3.049H5.549V7.415H2.5V5.549h3.049z\" transform=\"translate(3.268 4.763)\" style=\"fill:#292c32;\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };